var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from '../../lib/utils.js';
import { Form, FormControl, FormDescription, FormField, FormItem, FormMessage, FormLabel as ShadcnFormLabel, useFormField, } from './primitives/form';
function CustomFormLabel(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return <ShadcnFormLabel className={cn('block', className)} {...props}/>;
}
export { CustomFormLabel as FormLabel, Form, FormControl, FormDescription, FormField, FormItem, FormMessage, useFormField, };
